import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router';
import PageMeta from '../../components/PageMeta';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import {localePath} from '../../languages';

export default function ErrorPage({status = 404}) {
    const {t, i18n} = useTranslation();
    const notFound = status === 404;
    const heading = t(notFound ? 'pages.notFound.h1' : 'pages.error.h1');
    const description = t(notFound ? 'pages.notFound.description' : 'errors.unavailable');

    return (
        <>
            {notFound ? (
                <PageMeta page="notFound" robots="noindex, follow" />
            ) : (
                <>
                    <title>{`${heading} | YourLovely.Place`}</title>
                    <meta name="description" content={description} />
                    <meta name="robots" content="noindex, nofollow" />
                </>
            )}
            <Header />
            <main className="download-section not-found-section">
                <div className="design-container">
                    <div className="download-state not-found-card">
                        <span className="result-status-icon" aria-hidden="true">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            >
                                <path d="m7 7 10 10M17 7 7 17" />
                            </svg>
                        </span>
                        <span className="not-found-code">{status}</span>
                        <h1>{heading}</h1>
                        <p>{description}</p>
                        <Link className="design-button" to={localePath('/', i18n.language)}>
                            {t('pages.notFound.backHome')}
                        </Link>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
}
